// HomePage.js
import React, { useState, useEffect } from "react";
import Modal from "react-modal"; // Import React Modal
import ModalForm from "./Homeform.jsx"; // Import the ModalForm component
import styles from "./Home.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import heroBg from "../../assets/Home/Homebanner.png";
import bannersideimg from "../../assets/Home/banner_side_img.png";
import bannersideimgMobile from "../../assets/Home/banner_side_phone.png";
import SmartInvesting from "./SmartInvesting";
import Investment from "./Investment";
import Kyc from "./Kyc";
import HomeStrip from "./HomeStrip";
import ExpertTeam from "./ExpertTeam.jsx";
import ExpertsStrip from "./ExpertsStrip";
import Homefaqs from "./Homefaqs";
import AppDownload from "./AppDownload";
import { useNavigate } from "react-router-dom";
import InvestorJourney from "./InvestorJourney.jsx";

const HomePage = () => {
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState();

  useEffect(() => {
    let status = sessionStorage.getItem("homemodal");
    if (status == 2) {
      setModalIsOpen(false);
    } else {
      setModalIsOpen(true);
    }
  }, []);

  const closeModal = () => {
    setModalIsOpen(false);
    sessionStorage.setItem("homemodal", 2);
  };

  return (
    <div>
      <Navbar />
      <div className={styles.homePage__bannercontainer}>
        <section
          className={styles.homePage__heroSection}
          style={{
            backgroundImage: `url(${heroBg})`,
          }}
          id="home"
        >
          <div className={styles.homePage__heroContent}>
            <div className={styles.homePage__textWrapper}>
              <h1>
                Smart Investments. Absolute <br /> Trust. Alternative to
                Traditional Investing.
              </h1>
              <p>
                Earn predictable returns starting with Invoice discounting -
                where real businesses meet real investments.
              </p>
              <button
                className={styles.homebtn}
                onClick={() =>
                  navigate("/register", { state: { scrollToForm: true } })
                }
              >
                Start Investing
              </button>
            </div>
            <div className={styles.homePage__imgWrapper}>
              <img
                className={styles.desktopImage}
                src={bannersideimg}
                alt="Investment Banner"
              />
              {/* Mobile version */}
              <img
                className={styles.mobileImage}
                src={bannersideimgMobile}
                alt="Investment Banner Mobile"
                style={{ borderRadius: "10px" }}
              />
            </div>
          </div>
        </section>
        <SmartInvesting />
        <Investment  />
        <HomeStrip />
        <InvestorJourney />
        <Kyc />
        <ExpertsStrip />
        <ExpertTeam />
        <Homefaqs />
        <AppDownload />
        <Footer />
      </div>

      {/* React Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Investment Modal"
        ariaHideApp={false}
        // className={styles.HomeformModal}
        style={{
          content: {
            top: "58%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            borderRadius: "10px",
            backgroundColor: "#fff",
            width: "70vw",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <ModalForm closeModal={closeModal} />
      </Modal>
    </div>
  );
};

export default HomePage;
